module.exports = __webpack_public_path__ + "static/media/arrow-right-grey.a84a9f57.svg";